import { waitForContent, consoleMsg } from "../shared/utility";
import { showToast } from "../shared/navigation";

const app = window.app;

export class SubmissionComplete extends HTMLElement {
	async connectedCallback() {
		await waitForContent("submissionComplete");
		this.innerHTML = app.content.submissionComplete;

		this.addEventListener("ionViewDidEnter", () => {
			sessionStorage.removeItem("lastRoute");
			showToast("Inspection submitted successfully. You may now close this tab.", "success");

			/* Dev convenience with dummy data only: dismissing the toast also drops the
			submitted flag, so the same test inspection can be re-run on a device without
			digging into local storage by hand. Live submissions must keep the flag.
			The mode comes from the flag value itself, written at submission time — reading
			app.settings.liveData here is unsafe because NAVS index.php sets it from a
			DOMContentLoaded handler that can run after this page mounts on a reload. */
			if (localStorage.getItem("inspection-submitted") === "dummy") {
				document.getElementById("submission-toast-dismiss")?.addEventListener(
					"click",
					() => {
						localStorage.removeItem("inspection-submitted");
						consoleMsg("Dummy data: 'inspection-submitted' flag cleared on toast dismiss");
					},
					{ once: true },
				);
			}

			window.history.pushState(null, "", window.location.href);
			window.addEventListener("popstate", function () {
				window.history.pushState(null, "", window.location.href);
			});
		});
	}
}
